

















































import Vue from 'vue';
import { BigNumber } from 'ethers';
import { formatUnits } from '@ethersproject/units';
import { utils } from '@/store/ethers/ethersConnect';
import FillMaxButton from '@/components/FillMaxButton.vue';
import SelectdTokenButton from '@/components/SelectedTokenButton.vue';
import SelectTokenModal from '@/components/SelectTokenModal.vue';

export default Vue.extend({
  name: 'TokenAmountInput',
  components: {
    FillMaxButton,
    SelectdTokenButton,
    SelectTokenModal,
  },
  props: {
    otherTokenInfo: {
      type: Object,
      default: null,
    },
    pairList: {
      type: Array,
      default: () => [],
    },
    tokenInfo: {
      type: Object,
      default: null,
    },
    tokenLogo: {
      type: String,
      default: '',
    },
    isTokenSelected: {
      type: Boolean,
      default: false,
    },
    tokenAmount: {
      type: String,
      default: '',
    },
    isBadInputChange: {
      type: Function,
      default: () => {},
    },
    isToToken: {
      type: Boolean,
      default: false,
    },
    isUToken: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    amount: '',
    isModalShowing: false,
    isBadInput: false,
  }),
  computed: {
    formattedBalance(): string {
      if (!this.tokenInfo.balance) {
        return '0.0';
      }
      return formatUnits(this.tokenInfo.balance, this.tokenInfo.decimals);
    },
  },
  watch: {
    tokenAmount(val) {
      this.amount = val;
      const parsedAmount = utils.parseUnits(val, this.tokenInfo.decimals);
      const balance = BigNumber.from(this.tokenInfo.balance);
      this.isBadInput = parsedAmount.gt(balance);
    },
    isBadInput() {
      this.$emit('isBadInputChange', this.isBadInput);
    },
  },
  methods: {
    onAmountChange(ev: any) {
      const userInput = ev.target.value;
      this.setAmount(userInput);
    },
    setAmount(userInput: string) {
      try {
        const parsedAmount = utils.parseUnits(userInput || '0', this.tokenInfo.decimals);
        const balance = BigNumber.from(this.tokenInfo.balance);
        this.isBadInput = parsedAmount.gt(balance);
        this.$emit('amount-changed', userInput, parsedAmount);
      } catch (e) {
        console.warn(e);
        this.isBadInput = true;
      }
    },
    showTokenMenu() {
      this.isModalShowing = true;
    },
    fillMax() {
      this.setAmount(utils.formatUnits(this.tokenInfo.balance, this.tokenInfo.decimals).toString());
    },
    selectToken(payload: any) {
      this.$emit('select-token', payload.data);
    },
    clearSelectToken() {
      this.$emit('clear-select-token');
    },
  },
});
